import { createStore } from 'zustand';

export type HeaderStoreState = {
  isScrolled: boolean;
};

export const headerStore = createStore<HeaderStoreState>(() => ({
  isScrolled: false,
}));

export const setHeaderScrolled = (isScrolled: boolean) => {
  if (headerStore.getState().isScrolled === isScrolled) {
    return;
  }

  headerStore.setState({ isScrolled });
};
